var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemStoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.8vw",
    height: "0.8vw",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 5.33346L4.6665 3.00012L7.99984 2.00012L11.3332 3.00012L13.3332 5.33346V10.6668L11.3332 13.0001L7.99984 14.0001L4.6665 13.0001L2.6665 10.6668V5.33346Z",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 6.33346L5.99984 5.00012L7.99984 4.00012L9.99984 5.00012L11.3332 6.33346V9.77792L9.99984 11.3335L7.99984 12.0001L5.99984 11.3335L4.6665 9.77792V6.33346Z",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 13.0008L5.99984 11.3341",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99854 11.3341L11.3319 13.0008",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 3.00012L5.99984 5.00012",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99854 5.00012L11.3319 3.00012",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 5.33411L4.6665 6.33411",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99854 2.00012V4.00012",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 10.6661L4.6665 9.66614",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99854 14.0001V12.0001",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3306 10.6661L11.3306 9.66614",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3306 6.33411L13.3306 5.33411",
    stroke: "white",
    strokeWidth: 0.949091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemStoneIcon);
export default __webpack_public_path__ + "static/media/Gem_Stone_Icon.a8ca221a52888c1fcd84478edb22b0bc.svg";
export { ForwardRef as ReactComponent };